export enum DenialReason {
  MEDICAL_NECESSITY = "Not medically necessary",
  FORMULARY = "Not covered on formulary",
  SITE_OF_CARE = "Not covered at site of care",
  NETWORK = "Doctor not in network",
  PLAN_EXCLUSION = "Excluded plan benefit",
  STEP_THERAPY_REQUIRED = "Requires step therapy",
  FORCED_MEDICATION_SWITCH = "Forced switch by plan",
  QUANTITY_LIMITS_EXCEEDED = "Quantity limits exceeded",
  EXPERIMENTAL_OR_INVESTIGATIONAL = "Experimental or investigational",
  PA_REQUIREMENTS_NOT_MET = "PA requirements not met",
}
